import type React from 'react';

export interface KpiDeltaProps {
  value?: string;
  trend?: 'up' | 'down' | 'warn' | 'flat';
}

export function KpiDelta({ value, trend }: KpiDeltaProps): React.JSX.Element | null {
  if (value === undefined || value === '') return null;
  const arrow = trend === 'up' ? '↗' : trend === 'down' ? '↘' : trend === 'warn' ? '⚠' : '→';
  return (
    <span className={`kpi-delta kpi-delta--${trend ?? 'flat'}`}>
      {arrow} {value}
    </span>
  );
}
